module.exports = __webpack_public_path__ + "static/sec9-sm-bg-df225d3a0f176580d33252b609584576.jpg";